import { getChromeRuntime, getChromeTabs } from '../chrome/wrappers';
import { ChromeMessageType } from '../types';

/**
 * Notifies all open tabs with tampering checks to stop detecting and sending tampering events.
 */
export const cancelActiveTamperingChecks = async () => {
  // url values should always match the destination(s) where we run our content script
  const tabs = await getChromeTabs().query({
    url: ['http://*/*', 'https://*/*'],
  });
  for (const tab of tabs) {
    if (tab.id !== undefined) {
      try {
        await getChromeTabs().sendMessage(tab.id, {
          type: ChromeMessageType.CANCEL_TAMPERING_CHECKS,
        });
      } catch (error) {
        // Not all tabs could be running the content_script anti-tampering check,
        // and the message sending would fail in those cases.
        console.log('Tampering check could not be canceled for a tab.');
        console.log(error);
      }
    }
  }
};

/**
 * Listens for events to request the cancellation of tampering checks.
 */
export const setupTamperingChecksCancellationListener = (
  onCancel: () => void
) =>
  getChromeRuntime().onMessage.addListener((message, _sender, sendResponse) => {
    // Exclude other messages
    if (message.type !== ChromeMessageType.CANCEL_TAMPERING_CHECKS) {
      return;
    }
    onCancel();
    sendResponse();
    return false;
  });
